import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > window.innerHeight * 0.25) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 z-50 glass-card p-3 hover:bg-white/20 transition-all duration-300 hover:scale-110 focus:outline-hidden focus:ring-2 focus:ring-purple-400 group"
      aria-label="Pomaknite se na vrh strani"
      tabIndex={0}
    >
      <ArrowUp className="w-6 h-6 text-white group-hover:text-purple-300 transition-colors" />
    </button>
  );
};

export default ScrollToTop;